import * as yup from 'yup';

export const validationSchema = yup.object().shape({
    title: yup
        .string()
        .max(50, 'Не более 60 символов')
        .required('Поле является обязательным'),
    url: yup.string().required('Поле является обязательным'),
});
